import * as ModifyWorkspaceUsers from "./ModifyWorkspaceUsers";
import * as ModifyWorkspacePlan from "./ModifyWorkspacePlan";
import * as AiGeneration from "./AiGeneration";
import * as PaymentMethod from "./PaymentMethod";

import * as util from "./util";

const Analytics = {
    ModifyWorkspacePlan,
    ModifyWorkspaceUsers,
    AiGeneration,
    PaymentMethod,
    util
};

export default Analytics;
